import UserList from "@/views/user/UserList";
import UserAdd from "@/views/user/UserAdd";
import UserEdit from "@/views/user/UserEdit";
import invitedUserList from "@/views/user/invitedUserList";
import userPlanInfo from "@/views/user/userPlanInfo";
import UserActivityLogPage from "@/views/user/UserActivityLogPage";


const routes = [
 {
    path: '/user/List',
    name: 'UserList',
    component: UserList,
    meta:{requiredAuth:true}
  },
  {
    path: '/user/Add',
    name: 'UserAdd',
    component: UserAdd,
    meta:{requiredAuth:true}
  },
  {
    path: '/user/Edit/:id',
    name: 'UserEdit',
    component: UserEdit,
    meta:{requiredAuth:true}
  },
  {
    path: '/user/invitedUser/List/:id',
    name: 'invitedUserList',
    component: invitedUserList,
    meta:{requiredAuth:true}
  },
  {
    path: '/user/planInfo/:id',
    name: 'userPlanInfo',
    component: userPlanInfo,
    meta:{requiredAuth:true}
  },
  {
    path: '/user/activityLogPage/:id',
    name: 'UserActivityLogPage',
    component: UserActivityLogPage,
    meta:{requiredAuth:true}
  },
]

export default routes